import type { RedoInventoryRpcClient } from "@redotech/redo-merchant-inventory-rpc/client";
import { createRedoInventoryRpcClient } from "@redotech/redo-merchant-inventory-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoInventoryRpcClientContext: Context<
  RedoInventoryRpcClient | undefined
> = createContext<RedoInventoryRpcClient | undefined>(undefined);
RedoInventoryRpcClientContext.displayName = "RedoInventoryRpcClientContext";

export function RedoInventoryRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoInventoryRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoInventoryRpcClient({
      baseURL: new URL(`${baseUrl}/inventory-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoInventoryRpcClientContext.Provider value={redoInventoryRpcClient}>
      {children}
    </RedoInventoryRpcClientContext.Provider>
  );
}
